import React, {useState} from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MailIcon from '@mui/icons-material/Mail';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import './LeadCard.scss';
import config from '../../config/config';
import CustomCard from '../common/CustomCard';
import DoorIcon from '@mui/icons-material/DoorFront';
import LeadDialog from './LeadDialog';
import LeadDuplicateStatus from './LeadDuplicateStatus';
import LeadHasUpdates from './LeadHasUpdates';
import LeadStatus from './LeadStatus';
import {formatPhoneNumber} from '../../helpers/stringUtils';
import {formatProviderName} from '../../helpers/providers';
import {formatDate} from '../../helpers/dates';

const listItems = lead => [
  {
    Icon: null,
    children: <div style={{marginLeft: '-1.7em', width: '100%'}}>
      <Stack direction='row' alignItems='center' gap={1} justifyContent='space-between' flexGrow={1}>
        <LeadStatus lead={lead} includeStep={true} />
        <LeadHasUpdates lead={lead} />
        <LeadDuplicateStatus lead={lead} />
      </Stack>
    </div>,
    key: 'status',
  },
  {
    Icon: PersonIcon,
    text: <strong>{lead.contact_first_name} {lead.contact_last_name}</strong>,
    key: 'name',
  },
  {
    Icon: LocalHospitalIcon,
    text: formatProviderName(lead.provider),
    key: 'provider',
  },
  {
    Icon: DoorIcon,
    text: lead.referrer_name,
    key: 'referrer_name',
  },
  {
    Icon: PhoneIcon,
    text: formatPhoneNumber(lead.contact_phone),
    key: 'phone',
  },
];

const LeadCard = props => {
  const { lead } = props;
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  return (
    <>
      <LeadDialog
        lead={lead}
        dialogIsOpen={dialogIsOpen}
        onClose={() => {
          console.log('onClose!');
          setDialogIsOpen(false);
        }}
      />
      <Card 
        className='LeadCard' 
        style={{cursor: 'pointer', borderRadius: '1em'}} 
        onClick={() => setDialogIsOpen(true)}
      >
        <CustomCard
          listItems={listItems(lead)}
        >
          <Stack 
            direction='row' 
            alignItems='center' 
            justifyContent='space-between' 
            gap={1}
            padding={2}
            paddingTop={1.5}
            paddingBottom={0}
            marginBottom={0}
          >
            <Typography 
              variant='caption' 
              color='text.muted' 
              fontSize='0.675rem'
              fontStyle='italic'
            >
              Created {formatDate(lead.date_created)}
            </Typography>
            <Typography 
              variant='caption' 
              color='text.muted' 
              fontSize='0.675rem'
              fontStyle='italic'
            >
              Updated {formatDate(lead.date_updated)}
            </Typography>
          </Stack>
        </CustomCard>
      </Card>
    </>
  );
};

export default LeadCard;